/** Bucket used when a posted Project Update has no selected outcome. */
export const NO_OUTCOME_KEY = "__no_outcome__";

